import { Control, Controller } from 'react-hook-form'

import {
  MultiSelectFilterRow,
  MultiSelectFilterRowIProps,
} from './MultiSelectFilterRow'

type MultiSelectFilterFieldIProps<T> = Omit<
  MultiSelectFilterRowIProps<T>,
  'value' | 'onChange'
> & {
  control: Control<any>
  name: string
}

/**
 * `react-hook-form`-connected MultiSelectFilterRow: owns the `Controller` so a
 * drawer body can declare the field in one line instead of hand-writing the
 * render prop. Same precedent as `@/components/ui`'s `Controlled*` fields.
 * Seeded/reset by the form's `defaultValues` (see `./FilterDrawer`), so no
 * per-field `defaultValue` is needed.
 */
export const MultiSelectFilterField = <T,>({
  control,
  name,
  ...rowProps
}: MultiSelectFilterFieldIProps<T>) => (
  <Controller
    control={control}
    name={name}
    render={({ onChange, value }) => (
      <MultiSelectFilterRow {...rowProps} onChange={onChange} value={value} />
    )}
  />
)
